<div class="hbox" *ngIf="clinicalReport">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb pull-left">
          <li><a routerLink="/products/clinicalReport">Clinical Reports</a></li>
          <li>{{clinicalReportId ? 'Edit' : 'New'}}</li>
        </ul>
        <div class="pull-right">
          <button class="db" [disabled]="!clinicalReportForm.valid" (click)="saveClinicalReport()">{{clinicalReportId ? 'Update' : 'Create'}}</button>
        </div>
      </div>
    </div>
    <div class="flex-content">
      <form class="col-xs-12 p-4" #clinicalReportForm="ngForm">
        <div class="col-xs-12">
          <label class="col-xs-4 mt-0">Used For</label>
          <div class="col-xs-12">
            <input-select class="col-xs-5" [parseObj]="clinicalReport" name="usedFor" placeholder="Used For" [required]="true" [options]="usedForOptions"></input-select>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Main Concern</label>
          <div class="col-xs-12">
            <input-text class="col-xs-7" [parseObj]="clinicalReport" name="mainConcern" placeholder="Main Concern"></input-text>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Facewash</label>
          <div class="col-xs-12">
            <language-string-object-selection class="col-xs-7" [languageStringObject]="clinicalReport" [tags]="['clinicalReport']" name="facewash"></language-string-object-selection>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Moisturiser</label>
          <div class="col-xs-12">
            <language-string-object-selection class="col-xs-7" [languageStringObject]="clinicalReport" [tags]="['clinicalReport']" name="moisturiser"></language-string-object-selection>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Repair</label>
          <div class="col-xs-12">
            <language-string-object-selection class="col-xs-7" [languageStringObject]="clinicalReport" [tags]="['clinicalReport']" name="repair"></language-string-object-selection>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Analysis For User</label>
          <div class="col-xs-12">
            <language-string-object-selection class="col-xs-7" [languageStringObject]="clinicalReport" [tags]="['clinicalReport']" name="analysisForUser" [previewImage]="true"></language-string-object-selection>
          </div>
        </div>
        <div class="col-xs-12 mt-3">
          <label class="col-xs-4">Analysis For Doctor (JSON array)</label>
          <div class="col-xs-12">
            <textarea class="form-control col-xs-7" rows="6" name="analysisForDoctor" placeholder='[{ "key": "value" }]' [(ngModel)]="analysisForDoctorJSON"></textarea>
          </div>
        </div>
        <div class="col-xs-12 flex mt-3">
          <label class="mr-2">Active :</label>
          <input-checkbox [parseObj]="clinicalReport" name="active"></input-checkbox>
        </div>
      </form>
    </div>
  </div>
</div>
